<template>
    <rkm-modal
        :buttons="['cancel']"
        extraLarge
        ref="Modal"
        title="Arquivos"
    >
        <Form
            :additionals="additionals"
            :arquivos="arquivos"
            :item="item"
            :solicitacao="model"
            @arquivos-atualizados="handleArquivosAtualizados"
            @arquivos-preparados="handleArquivosPreparados"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        additionals: null,
        formData: null,
        item: [],
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item, model, additionals) {

            this.additionals = additionals
            this.item = item
            this.model = model
            this.$refs.Modal.show()
        },
        handleArquivosPreparados(arquivos, data) {
            this.arquivosPreparados = arquivos;
            this.formData = data;
            this.$emit('addArquivos', this.arquivosPreparados, this.formData);
        },
        handleArquivosAtualizados(arquivos, data) {
            this.arquivosPreparados = arquivos;
            this.formData = data;
            this.$emit('addArquivos', this.arquivosPreparados, this.formData);
        },
    },
    props: {
        arquivos: { type: Array, default: () => [] },
    },
}
</script>